var exports = {
  "k": "x0a7806d5--be2c22--container",
  "n": "x0a7806d5--be2c22--link",
};

module.exports = exports;
